import React from 'react';

const IconEdit = props => (<svg viewBox="0 0 24 24" width="24px" height="24px" {...props}>
  <path d="M15.559 2.482L2.518 15.561l-0.012 5.957h5.946L21.494 8.435L15.559 2.482z M18.747 8.435l-2.312 2.319 l-3.189-3.197l2.313-2.319L18.747 8.435z M7.647 19.57H4.452l0.006-3.201l7.415-7.436l3.189 3.198L7.647 19.57z" />
</svg>);

export default IconEdit;
